export default __webpack_public_path__ + "static/media/stonewell_logo_col.5057a3ab.png";